<template>
    <div>
        <div class="hidden ml-12 mr-5 pb-4 grid-cols-12 text-sm font-semibold sm:grid">
            <div class="col-span-3">Type</div>
            <div class="col-span-2">Sends</div>
            <div class="col-span-3">Starts</div>
            <div class="col-span-4">Ends</div>
        </div>
        <vx-radio-selection :disabled="props.disabled"
            :modelValue="props.modelValue"
            aria-label="Campaign type"
            @update:modelValue="changeModelValue($event)"
            @keydown.down.exact.capture="moveRadioFocus($event, 1)"
            @keydown.right.exact.capture="moveRadioFocus($event, 1)"
            @keydown.up.exact.capture="moveRadioFocus($event, -1)"
            @keydown.left.exact.capture="moveRadioFocus($event, -1)">
            <vx-radio-selection-item value="one_time" data-test="campaign-type-one_time">
                <div :class="tableRow">
                    <div class="col-span-3">Blast</div>
                    <div :class="[tableCell, 'col-span-2']">
                        <span class="sm:hidden">Sends:</span> Once
                    </div>
                    <div :class="[tableCell, 'col-span-3']">
                        <span class="sm:hidden">Starts:</span> On date selected
                    </div>
                    <div :class="[tableCell, 'col-span-4']">
                        <span class="sm:hidden">Ends:</span> After messages sends
                    </div>
                </div>
            </vx-radio-selection-item>
            <vx-radio-selection-item value="evergreen" data-test="campaign-type-evergreen">
                <div :class="tableRow">
                    <div class="col-span-3">Evergreen</div>
                    <div :class="[tableCell, 'col-span-2']">
                        <span class="sm:hidden">Sends:</span> Continuously
                    </div>
                    <div :class="[tableCell, 'col-span-3']">
                        <span class="sm:hidden">Starts:</span> On date selected
                    </div>
                    <div :class="[tableCell, 'col-span-4']">
                        <span class="sm:hidden">Ends:</span> Not until stopped
                    </div>
                </div>
            </vx-radio-selection-item>
        </vx-radio-selection>
        <vx-modal v-model:visible="confirmModal"
            :padding="false"
            size="md">

            <template v-slot:header>
                <div class="py-6 px-6">
                    Campaign Type
                </div>
            </template>
            <div class="p-6">
                <vx-alert color="info" :closeable="false">
                    Are you sure? Changing the campaign type will mean contacts cannot be messaged more than once.
                </vx-alert>
            </div>

            <template v-slot:footer>
                <div class="flex flex-col-reverse gap-4 lg:flex-row">
                    <vx-button @click="cancelChange()"
                        type="button"
                        class="grow lg:w-20 lg:grow-0"
                        size="lg"
                        color="muted">
                        Cancel
                    </vx-button>
                    <vx-button @click="confirmChange()"
                        type="button"
                        class="grow"
                        size="lg"
                        color="primary">
                        Confirm
                    </vx-button>
                </div>
            </template>

        </vx-modal>
    </div>
</template>
<script setup>
import { nextTick, ref } from 'vue'
import { VxAlert, VxButton, VxRadioSelection, VxRadioSelectionItem, VxModal } from '@voxie/frontend-components';
import { moveRadioFocus } from '~/utils/dom';

const props = defineProps({
    modelValue: {
        type: String,
    },
    campaignId: {
        type: Number,
    },
    isRepeatable: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const tableCell = 'text-xs text-slate-500 font-normal';
const tableRow = 'block grid-cols-12 items-center w-full sm:grid';

const emit = defineEmits(['update:modelValue', 'update:isRepeatable']);

const newModelValue = ref(props.modelValue);

const confirmModal = ref(false);

const changeModelValue = ($event) => {
    if (!props.isRepeatable || $event !== 'one_time') {
        emit('update:modelValue', $event);
        return;
    }
    newModelValue.value = $event;
    confirmModal.value = true;
}

const cancelChange = () => {
    confirmModal.value = false;
}

const confirmChange = async () => {
    emit('update:modelValue', newModelValue.value);
    await nextTick();
    emit('update:isRepeatable', false);
    confirmModal.value = false;
}

</script>
